import api from './axios';
import axios from 'axios';

interface Directory {
    name: string;
    path: string;
    type: string;
    children: Directory[];
}

// Create a folder
export const createFolder = async (folderPath: string) => {
    try {
        await api.post('/assets/create-folder', { folderPath });
        return true;
    } catch (error) {
        console.error('Error creating folder:', error);
        throw error;
    }
};

// Delete a folder 
export const deleteFolder = async (folderPath: string) => {
    await api.delete(`/assets/delete-folder`, { data: { folderPath } });
    return true;
};

// Upload a file with progress reporting
export const uploadFile = async (
    file: File, 
    folderPath: string, 
    onProgress: (progress: number) => void
) => {
    try {
        const response = await api.post('/assets/presigned-url', {
            filename: file.name,
            contentType: file.type,
            folderPath: folderPath,
            fileSize: file.size
        });

        await axios.put(response.data.url, file, {
            headers: { 'Content-Type': file.type },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
                onProgress(percentCompleted);
            }
        });

        return true;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
    }
};

// Delete a file
export const deleteSingleFile = async (id: string) => {
    try {
        await api.delete(`/assets/delete/${id}`);
        return true;
    } catch (error) {
        console.error('Error deleting file:', error);
        throw error;
    }
};

// Fetch directories and return them in a nested structure
export const fetchDirectories = async (folderPath: string): Promise<Directory[]> => {
    try {
        const response = await api.get(`/assets/list-directories?folderPath=${folderPath}`);
        return response.data.directories;
    } catch (error) {
        console.error('Error fetching directories:', error);
        throw error;
    }
};

// Fetch files with pagination
export const fetchFiles = async (folderPath: string, page: number) => {
    const response = await api.get(`/assets/list-files?folderPath=${folderPath}&page=${page}`);
    return {
        files: response.data.files,
        totalCount: response.data.totalCount,
        currentPage: response.data.currentPage,
        totalPages: response.data.totalPages
    };
};

export const fetchStorageUsage = async () => {
    const response = await api.get(`/assets/storage-usage`);
    return response.data;
}

// Search files with pagination
export const searchFiles = async (query: string, page: number, limit: number = 10) => {
    const response = await api.get(`/assets/search-files`, {
        params: { query, page, limit }
    });
    return {
        files: response.data.files,
        totalCount: response.data.totalCount,
        currentPage: response.data.currentPage,
        totalPages: response.data.totalPages
    };
};